module.exports = __webpack_public_path__ + "img/img-6.19a30f7.jpg";